import { connect } from 'react-redux'
import { chatbotSelectors, getStep, PortfolioWizardStepNames } from 'modules/ui/ChatBot'
import { ChatBot } from '../../components'
import { portfolioEvents } from 'modules/portfolios/state'

const mapStateToProps = (state, { push }: any) => ({
  actions: [],
  step: getStep(PortfolioWizardStepNames.owners),
  displayStep: chatbotSelectors.getCurrentPortfolioStatus(state) === 'in progress',
  title: 'Owners',
  displayTitleAction: true,
  titleActionText: 'Add owner',
})

const mapDisptchToProps = (dispatch: any) => ({
  actionClickHandler: (action: any) => dispatch(action()),
  titleActionClickHandler: () => dispatch(portfolioEvents.togglePartyModal()),
})

export default connect(mapStateToProps, mapDisptchToProps)(ChatBot)
